const normalizeRating = (rating) => {
  if (isNaN(rating)) {
    return 0
  }
  return rating
}
export const calcCategoryGoalRatingAvg = (ratings) => {
  // just takes all goals in a category and calcs an average
  if (ratings.length === 0) {
    return 0
  }
  // average the ratings for the category goals
  const categoryRating = ratings.reduce((sum, rating) => sum + normalizeRating(rating), 0) / ratings.length
  return categoryRating
}
